<template>
  <p-app theme="glittr exterior">
    <p-toolbar slot="header" color="base">
      <p-img width="130" height="50" to="/_exterior/login" contain :src="require('@src/assets/logo.svg')"></p-img>
    </p-toolbar>
    <p-container slot="default" fill-height>
      <p-row justify-center>
        <p-col xs12 md10 lg8 xl6>
          <p-card class="mt-4" color="white">
            <slot class="content" />
          </p-card>
        </p-col>
      </p-row>
    </p-container>
  </p-app>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    name: 'LayoutExterior',
    data: () => ({
      theme: 'glittr-pixel-light',
    }),
  });
</script>
